export const productShortName = 'Substation Engineering & Protection Systems — Professional Edition™';
export const productBrand = 'Substation Engineering & Protection Systems';
export const productEdition = 'Professional Edition™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/bGkzL5DrMhnSxbLVbasK6o/MOCKUP_Ingenieria_de_Subestaciones.png';
export const productImageAlt =
  'Substation Engineering & Protection Systems Professional Edition: six volumes covering substation fundamentals, primary equipment, protection and relays, grounding and lightning protection, control and automation, and testing and maintenance, plus five bonus resources';

export const checkoutUrl = 'https://substation-engineering-protection-systems.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion when reading single-line diagrams',
  'No more uncertainty about transformers, breakers, CTs and VTs',
  'No more gaps in understanding how protection relays detect and clear faults',
  'No more doubts about earthing, insulation and lightning protection',
  'No more walking into technical interviews unprepared',
];
